<p-confirmDialog [key]="key" [closable]="true" [draggable]="false" [pt]="pt"></p-confirmDialog>
